<script lang="ts" setup>
import InputGroupAddon from 'primevue/inputgroupaddon';

interface VInputGroupAddonProps {
  hasError?: boolean;
}

const props = defineProps<VInputGroupAddonProps>();
</script>

<template>
  <InputGroupAddon v-bind="props">
    <slot></slot>
  </InputGroupAddon>
</template>
